import React from 'react'
import dynamic from 'next/dynamic'
import { Container, Row, Col } from 'react-bootstrap'

import Error from '@shared/components/error'
import Layout from '@shared/components/layout'
import { useRouter } from 'next/router'
import { navLoader, pageLoading } from '@shared/libs/allLoader'
import { GET_TAG_ARTICLE } from '@graphql/tag/tag.query'
import { GET_TEAM_MINI_SCORECARD, GET_TEAM_MATCHES } from '@graphql/teams/teams.query'
import { WIDGET } from '@shared-submodule/sm-constants'
import useWindowSize from '@shared/hooks/windowSize'
import { GET_TEAM_FORM } from '@graphql/match/match.query'
import { arraySortByOrder, parallelCalls } from '@shared-submodule/utils'
// import { googleAddData } from '@shared-submodule/sm-constants/googleAdsData'
// import { skyAddData } from '@shared/constants/skyAds'
import { ENUM_CRICKET_TEAM_PAGES } from '@shared-submodule/sm-enum'
import { reviveAdData } from '@shared/components/reviveAds/reviveAdData'

// const GoogleAds = dynamic(() => import('@shared-submodule/sm-components/googleAds'), { ssr: false })
const TeamHeader = dynamic(() => import('@shared/components/team/teamHeader'))
const TeamOverview = dynamic(() => import('@shared/components/team/teamOverview'))
const CommonNav = dynamic(() => import('@shared/components/commonNav'), { loading: () => navLoader() })
const TeamNews = dynamic(() => import('@shared/components/team/teamNews'), { loading: () => pageLoading() })
const TeamMatch = dynamic(() => import('@shared/components/team/teamMatch'), { loading: () => pageLoading() })
const AllWidget = dynamic(() => import('@shared/components/allWidget'), { ssr: false })
const ATSAds = dynamic(() => import('@shared/components/atsAds'), { ssr: false })
const ReviveAds = dynamic(() => import('@shared/components/reviveAds'), { ssr: false })
function teamProfile({ teamData, article, seoData, miniScorecard, teamMatch, teamFormInput }) {
  const router = useRouter()
  const [width] = useWindowSize()
  const subPages = teamData.oTeamSeos?.oSeo
  function getNavItems() {
    const items = []
    subPages?.forEach(t => {
      if (ENUM_CRICKET_TEAM_PAGES[t?.eSubType]) {
        items.push({
          navItem: ENUM_CRICKET_TEAM_PAGES[t?.eSubType],
          url: `/${t?.sSlug}`,
          active: t?.eSubType === seoData?.eSubType
        })
      } else if (t?.eSubType === null) {
        // Home Tab
        items.push({
          navItem: ENUM_CRICKET_TEAM_PAGES.o.replaceAll(/-/gi, ' '),
          url: `/${t?.sSlug}`,
          active: t?.eSubType === seoData?.eSubType
        })
      }
    })
    const order = ['overview', 'news', 'match']
    return arraySortByOrder({ data: items, order, key: 'navItem' })
  }

  const teamContent = () => {
    if (router?.asPath === `/${teamData?.oSeo?.sSlug}`) {
      return <TeamOverview teamData={teamData} article={article} miniScorecard={miniScorecard} teamFormInput={teamFormInput} />
    } else if (router?.asPath === `/${teamData?.oSeo?.sSlug}/news`) {
      return <TeamNews data={article} teamData={teamData} />
    } else if (router?.asPath === `/${teamData?.oSeo?.sSlug}/match`) {
      return <TeamMatch teamMatch={teamMatch} />
    }
  }

  const { addTop, mobSm, addBottom, addRight, addLeft, add300 } = reviveAdData
  const randomAd = Math.random() < 0.5 ? addLeft : add300

  return (
    <Layout data={{ ...teamData, oSeo: seoData }}>
      <ATSAds />
      <Container className="pt-3">
        <Row>
          <Col lg={9} className="left-content">
            <TeamHeader data={teamData} />
            <div className="w-full d-none d-xl-flex justify-content-center ">
              {/* <GoogleAds
                addId={googleAddData?.addTop?.addId}
                divId={googleAddData?.addTop?.divId}
                dimension={googleAddData?.addTop?.dimension}
                slotId={googleAddData?.addTop?.slotId}
                className={'mt-2 mb-0'}
              /> */}
              <ReviveAds {...addTop} className={'mt-2 mb-0'}/>
            </div>
            <div className="w-full d-flex d-xl-none justify-content-center ">
              {/* <GoogleAds
                addId={googleAddData?.mobSm?.addId}
                divId={googleAddData?.mobSm?.divId}
                dimension={googleAddData?.mobSm?.dimension}
                slotId={googleAddData?.mobSm?.slotId}
                className={'mt-4 mb-0'}
              /> */}
              <ReviveAds {...mobSm} className={'mt-4 mb-0'}/>
            </div>
            <CommonNav items={getNavItems()} />
            {teamContent()}
            {width > 1400 && (
              // <GoogleAds
              //   addId={skyAddData?.addBottom?.addId}
              //   divId={skyAddData?.addBottom?.divId}
              //   dimension={skyAddData?.addBottom?.dimension}
              //   slotId={skyAddData?.addBottom?.slotId}
              //   className={'my-3'}
              // />
              <ReviveAds {...addBottom} className={'my-3 text-center'}/>
            )}
            {width < 1000 && (
              //  <GoogleAds
              //   addId={skyAddData?.addRight?.addId}
              //   divId={skyAddData?.addRight?.divId}
              //   dimension={skyAddData?.addRight?.dimension}
              //   slotId={skyAddData?.addRight?.slotId}
              //   className={'my-3'}
              // />
              <ReviveAds {...randomAd} className={'d-flex justify-content-center my-3'}/>
            )}
          </Col>
          {width > 991 && (
            <Col lg={3} className="common-sidebar">
              <ATSAds />
              <AllWidget type={WIDGET.trendingNews} show />
              {/* <GoogleAds
                addId={googleAddData?.addRight?.addId}
                divId={googleAddData?.addRight?.divId}
                dimension={googleAddData?.addRight?.dimension}
                slotId={googleAddData?.addRight?.slotId}
                className={'sticky_ads mb-3'}
              /> */}
              <ReviveAds {...addRight} className={'d-flex justify-content-center sticky_ads mb-3'}/>
            </Col>
          )}
        </Row>
      </Container>
    </Layout>
  )
}

export default Error(teamProfile)

export async function getServerSideProps({ req, res, params, query, resolvedUrl }) {
  const { checkPageNumberInSlug } = await import('@shared-submodule/utils')
  const { slug, secondLast, lastSlug } = checkPageNumberInSlug([...params?.slug], false)

  try {
    const queryGraphql = (await import('@shared/components/queryGraphql')).default
    const { checkRedirectionStatus } = await import('@shared-submodule/utils')
    const GET_SEO_DATA = (await import('@graphql/article/article.query')).GET_SEO_DATA
    const { data: seo } = await queryGraphql(GET_SEO_DATA, { input: { sSlug: `cricket/teams/${slug?.join('/')}` } })
    const { redirectStatus, eCode, returnObj, props } = checkRedirectionStatus(seo?.getSeoData)
    if (redirectStatus && props) {
      res.statusCode = eCode
      return { props }
    } else if (redirectStatus) return returnObj
    if (seo?.getSeoData?.eType === 't' && seo?.getSeoData?.eStatus === 'a') {
      res.setHeader('Cache-Control', 'public, max-age=420')
      const GET_TEAM_BY_ID = (await import('@graphql/teams/teams.query')).GET_TEAM_BY_ID
      const { data: teamData } = await queryGraphql(GET_TEAM_BY_ID, { input: { _id: seo?.getSeoData?.iId } })

      if (teamData?.getTeamByIdFront?.eTagStatus === 'a' && lastSlug === 'news') {
        const { data: article } = await queryGraphql(GET_TAG_ARTICLE, {
          input: { _id: seo?.getSeoData?.iId, eType: seo?.getSeoData?.eType, nLimit: 16, nSkip: 0, sSortBy: 'dCreated', nOrder: -1 }
        })
        return {
          props: {
            seoData: seo?.getSeoData,
            teamData: teamData?.getTeamByIdFront,
            article: article?.getTagArticlesFront || []
          }
        }
      } else if (teamData?.getTeamByIdFront?.eTagStatus === 'a' && lastSlug === 'match') {
        const { data: teamMatch } = await queryGraphql(GET_TEAM_MATCHES, { input: { iTeamId: seo?.getSeoData?.iId } })
        return {
          props: {
            seoData: seo?.getSeoData,
            teamData: teamData?.getTeamByIdFront,
            teamMatch: teamMatch?.getTeamMatches
          }
        }
      } else if (teamData?.getTeamByIdFront?.eTagStatus === 'a' && !secondLast) {
        const [miniScorecard, teamFormData, article] = await parallelCalls([
          queryGraphql(GET_TEAM_MINI_SCORECARD, { input: { iTeamId: seo?.getSeoData?.iId } }),
          queryGraphql(GET_TEAM_FORM, { input: { iTeamId: teamData?.getTeamByIdFront?._id, nLimit: 5 } }),
          queryGraphql(GET_TAG_ARTICLE, {
            input: { _id: seo?.getSeoData?.iId, eType: seo?.getSeoData?.eType, nLimit: 6, nSkip: 0, sSortBy: 'dCreated', nOrder: -1 }
          })
        ])
        return {
          props: {
            seoData: seo?.getSeoData,
            teamData: teamData?.getTeamByIdFront,
            article: article?.getTagArticlesFront,
            miniScorecard: miniScorecard?.getTeamMiniScorecard,
            teamFormInput: teamFormData?.getTeamForm
          }
        }
      } else {
        return {
          notFound: true
        }
      }
    } else {
      return {
        notFound: true
      }
    }
  } catch (e) {
    console.log({ e })
    res.setHeader('Cache-Control', 'no-cache')
    const handleApiError = (await import('@shared-submodule/utils')).handleApiError
    const status = handleApiError(e, resolvedUrl)
    return status
  }
}
